import React, { useState, useEffect } from 'react';
import NavBar from './NavBar';
import { FaBars, FaTimes} from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import './Sectors.css';
import imageFashion from './assets/images/fashion.jpg';
import imageIT from './assets/images/man-with-headphones-facing-computer-monitor-845451-2048x1365-1.jpg';
import imageConsumer from './assets/images/consumer-products.jpg';
import imagebusiness from './assets/images/business-to-business-services.jpg';
import imagecleantech from './assets/images/cleantech-1-scaled-1.jpg';
import imagefintech from './assets/images/sectors-page-fintech.jpg';
import imagelifescience from './assets/images/Life-Science.jpg';
import imageCommerce from './assets/images/shop.jpg';
import imagefood from './assets/images/Food-and-beverage-industry-factory.jpg';
import imageTechnology from './assets/images/image123-1.jpg';
import imageSpeciality from './assets/images/speciality-manufacturing-1-1.jpg';
import imageChemical from './assets/images/chemical-and-industrials.jpg';
import logo1 from './assets/images/0040C0.png';
import logo from './assets/images/favicon1.webp';

const Sectors = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    useEffect(() => {
        document.title = "Sectors – Bay Capital Advisors";
        
        // Find and update the favicon
        let favicon = document.querySelector("link[rel~='icon']");
        if (!favicon) {
          favicon = document.createElement('link');
          favicon.rel = 'icon';
          document.head.appendChild(favicon);
        }
        favicon.href = logo; // Use your logo as favicon
        
        return () => {
          // Reset title when component unmounts if needed
          document.title = "Bay Capital Advisors";
        };
      }, []);
      
        const toggleMobileMenu = () => {
          setIsMobileMenuOpen(!isMobileMenuOpen);
        };
      
        const closeMobileMenu = () => {
          setIsMobileMenuOpen(false);
        };
    return (
      <div className="sectors-page">
         <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-overlay" onClick={closeMobileMenu}>
          <div className="mobile-dropdown" onClick={(e) => e.stopPropagation()}>
            <NavBar isMobile={true} closeMenu={closeMobileMenu} />
          </div>
        </div>
      )}
        <section class="hero2">
    
        <div class="blue-overlay"></div>
    
    <header class="header2">
    <NavBar />
  </header>

        <header className="sectors-header">
          <h1>SECTORS</h1>
          <p>Teams with Deep Industry Understanding Providing Seamless Execution</p>
        </header>
        </section>
        
        <section className="sectors-section">
            <p className="sectors-description">
                We have teams aligned along industries and sectors. This allows our teams to have a depth of understanding of our client’s businesses that is unparalleled, enabling us to present compelling strategic opportunities to shareholders and founders in areas like joint ventures, capitalization, restructuring, partnerships, strategic alliances, mergers, and acquisitions.
                <br /><br />
                From engagement, our teams invest tremendous time understanding the complexities of your business. In this way, we are able to bring the right opportunities to fruition for our clients that help them really drive their business forward in the right direction.
            </p>

            <div className="sectors-images">
                <div className="sector-card">
                    <img src={imageTechnology} alt="Technology & Software" className="sector-image" />
                    <p className="sector-name">Technology & Software</p>
                </div>
                <div className="sector-card">
                    <img src={imageConsumer} alt="Consumer Products" className="sector-image" />
                    <p className="sector-name">Consumer Products</p>
                </div>
                <div className="sector-card">
                    <img src={imagebusiness} alt="Business" className="sector-image" />
                    <p className="sector-name">Business to Business Services</p>
                </div>
                
            </div>


            <div className="sectors-images">
                <div className="sector-card">
                    <img src={imageCommerce} alt="E-Commerce" className="sector-image" />
                    <p className="sector-name">E-Commerce</p>
                </div>
                <div className="sector-card">
                    <img src={imagelifescience} alt="Healthcare & Life Sciences" className="sector-image" />
                    <p className="sector-name">Healthcare & Life Sciences</p>
                </div>
                <div className="sector-card">
                    <img src={imageFashion} alt="Fashion & Retail" className="sector-image" />
                    <p className="sector-name">Fashion & Retail</p>
                </div>
                
            </div>


            <div className="sectors-images">
                <div className="sector-card">
                    <img src={imageIT} alt="IT Services" className="sector-image" />
                    <p className="sector-name">IT Services</p>
                </div>
                <div className="sector-card">
                    <img src={imageSpeciality} alt="Specialty Manufacturing" className="sector-image" />
                    <p className="sector-name">Specialty Manufacturing</p>
                </div>
                <div className="sector-card">
                    <img src={imageChemical} alt="Industrials & Chemicals" className="sector-image" />
                    <p className="sector-name">Industrials & Chemicals</p>
                </div>
                
            </div>

            <div className="sectors-images">
                <div className="sector-card">
                    <img src={imagefood} alt="Food & Beverage" className="sector-image" />
                    <p className="sector-name">Food & Beverage</p>
                </div>
                <div className="sector-card">
                    <img src={imagefintech} alt="Fintech" className="sector-image" />
                    <p className="sector-name">Fintech</p>
                </div>
                <div className="sector-card">
                    <img src={imagecleantech} alt="Clean Tech" className="sector-image" />
                    <p className="sector-name">Clean Tech</p>
                </div>
                
            </div>
            
            
        </section>
         {/* Footer Section */}
    <div className="footer-section">
        <nav>
          <a href="/CoreValues">Core Values</a>
          <a href="/Resources">Resources</a>
          <a href="/ContactUs">Contact Us</a>
        </nav>
        <div className="footer-logo">
                <Link to="/"> {/* Add this Link wrapper */}
                  <img src={logo1} alt="Bay Capital Advisors Logo" className="logo" />
                </Link>
                </div>
        <nav>
          <a href="/PrivacyPolicy">Privacy Policy</a>
          <a href="/TermsOfService">Terms of Service</a>
        </nav>
      </div>
      </div>
    );
};

export default Sectors;
